import * as Actions from '../actions/sidebar-actions';

const initialState = {
  sidebarAgenda: { show: false },
  entityChannelSidebar: { show: false },
  locationSidebar: { show: false },
  structureSidebar: { show: false },
  editBlockPulseSidebar: { show: false },
  sidebarNodeAI: { show: false },
};

export const sidebarReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case Actions.RESET_SIDEBAR_STATE:
      return initialState;
    case Actions.CLEAR_STATE:
      return initialState;
    case Actions.SIDEBAR_AGENDA:
      return { ...initialState, sidebarAgenda: payload };
    case Actions.SIDEBAR_NODE_AI:
      return { ...initialState, sidebarNodeAI: payload };
    case Actions.ENTITY_CHANNEL_SIDEBAR:
      return { ...initialState, entityChannelSidebar: payload };
    case Actions.LOCATION_SIDEBAR:
      return { ...initialState, locationSidebar: payload };
    case Actions.STRUCTURE_SIDEBAR:
      return { ...initialState, structureSidebar: payload };
    case Actions.EDIT_BLOCK_PULSE_SIDEBAR:
      return { ...initialState, editBlockPulseSidebar: payload };
    default:
      return state;
  }
};
